<template>
	<a href="javascript:;" class="v5-tab-item" :class="{'v5-tab-item-selected':isSelected}" @click="updateActiveId">
		<slot>
		</slot>
	</a>
</template>
<script>
export default {
	name: 'v5-tab-item',
	props: {
		id: [String, Number],
		selected: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		updateActiveId() {
			this.$parent.$emit('input', this.id);
			this.$parent.$emit('on-change', this.id);
		}
	},
	watch: {
		activeId(val) {
			if (this.id === val) {
				this.selected = true;
			}
		}
	},
	data() {
		return {
			isSelected: this.selected
		};
	},
	mounted() {
		if (this.isSelected) {
			this.updateActiveId();
		}
		this.$on('update', val => {
			if (val === this.id) {
				this.isSelected = true;
			} else {
				this.isSelected = false;
			}
		});
	}
};
</script>
<style lang="scss">
@import './style.scss';
</style>
